import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-739ae849"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-info" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "list-style-none" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" MRB provides clients with the most powerful, industry-leading API functionalities. You can use API to check market data, process automated trading orders and much more. See "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        target: "_blank"
      }, "API Documentation page"),
      /*#__PURE__*/_createTextVNode(" for more details. ")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, " Each account can have up to 20 keys. For security reasons, please do not reveal your key(s) to non-trusted third parties. "),
    /*#__PURE__*/_createElementVNode("li", null, " For the safety of your assets, your API secret key will only appear once upon creation, and hidden afterwards. "),
    /*#__PURE__*/_createElementVNode("li", null, "Please keep your API keys securely.")
  ])
], -1))
const _hoisted_4 = { class: "mt-8" }
const _hoisted_5 = ["data-bs-target"]
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Create API Key ")
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-header border-0 pt-6" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_12 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end",
    "data-kt-customer-table-toolbar": "base"
  })
], -1))
const _hoisted_14 = {
  key: 0,
  class: "card-body pt-0"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "d-flex gap-2" }
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notice = _resolveComponent("Notice")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_APIKeyModal = _resolveComponent("APIKeyModal")!
  const _component_StripeModal = _resolveComponent("StripeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Notice, {
          classes: "rounded-3 mb-8",
          color: "warning",
          title: "IMPORTANT NOTE!",
          icon: "media/icons/duotune/general/gen044.svg"
        }),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_ctx.$hasPerms(_ctx.user, [_ctx.$perms.ADD_API_KEY]))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": `#${_ctx.$modals.API_KEY_MODAL}`
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                ]),
                _hoisted_7
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-15",
              placeholder: "Search Keys"
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        _hoisted_13
      ]),
      (_ctx.tableData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_openBlock(), _createBlock(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": false,
              key: _ctx.tableKey
            }, {
              "cell-name": _withCtx(({ row: apiKey }) => [
                _createTextVNode(_toDisplayString(apiKey.name), 1)
              ]),
              "cell-key": _withCtx(({ row: apiKey }) => [
                _createElementVNode("span", {
                  class: "fw-bolder text-hover-primary pointer",
                  onClick: ($event: any) => (_ctx.revealKey($event, apiKey.key))
                }, "*********************************************", 8, _hoisted_15)
              ]),
              "cell-limit": _withCtx(({ row: apiKey }) => [
                _createTextVNode(_toDisplayString(apiKey.limit), 1)
              ]),
              "cell-no_uses": _withCtx(({ row: apiKey }) => [
                _createTextVNode(_toDisplayString(apiKey.no_uses), 1)
              ]),
              "cell-services_display": _withCtx(({ row: apiKey }) => [
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apiKey.services_display || [], (service) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: service,
                      class: "badge badge-light-primary"
                    }, _toDisplayString(service), 1))
                  }), 128))
                ])
              ]),
              "cell-edit": _withCtx(({ row: apiKey }) => [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-light btn-active-light-primary m-1",
                  onClick: ($event: any) => (_ctx.copyKey($event, apiKey))
                }, " Copy ", 8, _hoisted_17)
              ]),
              _: 1
            }, 8, ["table-data", "table-header"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_APIKeyModal, {
      plans: _ctx.plans,
      fees: _ctx.feeBreakdown,
      "apply-fee-fn": _ctx.applyFees,
      loading: _ctx.loadingPlans,
      onSubmit: _ctx.handleSubmit
    }, null, 8, ["plans", "fees", "apply-fee-fn", "loading", "onSubmit"]),
    _createVNode(_component_StripeModal, {
      "client-secret": _ctx.stripeSecret,
      onSuccess: _ctx.processPayStackPayment
    }, null, 8, ["client-secret", "onSuccess"])
  ], 64))
}